// extracted by mini-css-extract-plugin
module.exports = {"attachments_grand_container":"Attachments_attachments_grand_container__3_6qL","attachments_container":"Attachments_attachments_container__g2TvJ"};